/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PartnerlistNotificationType {
    ReadPartnerlist = 0,
    AddPartnerlistPartner = 1,
    AddPartnerlistPartnerRequestReceived = 2,
    UpdatePartnerlistPartner = 3,
    DeletePartnerlistPartner = 4,
    ReadPartnerlistGroups = 5,
    AddPartnerlistGroup = 6,
    UpdatePartnerlistGroup = 7,
    DeletePartnerlistGroup = 8,
    OwnOnlineStateUpdate = 9,
    PartnerOnlineStateUpdate = 10,
}
